
import { db } from './firebase';
import { collection, addDoc, getDocs, query, where, doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import type { FunnelSubmission } from '@/components/FunnelBuilder/types';

export const createSubmission = async (funnelId: string, formData: Record<string, any>) => {
  const submission: Omit<FunnelSubmission, 'id'> = {
    funnelId,
    formData,
    createdAt: new Date().toISOString(),
    paymentStatus: 'pending'
  };

  // Get or create the submissions document for this funnel
  const submissionsRef = doc(db, 'funnel_submissions', funnelId);
  const submissionsDoc = await getDoc(submissionsRef);

  // Get funnel data to check notification settings
  const funnelRef = doc(db, 'funnels', funnelId);
  const funnelDoc = await getDoc(funnelRef);
  const funnelData = funnelDoc.data();

  if (!submissionsDoc.exists()) {
    // Create new submissions document for this funnel
    await setDoc(submissionsRef, {
      submissions: [submission]
    });
  } else {
    // Update existing submissions document
    const currentSubmissions = submissionsDoc.data().submissions || [];
    await updateDoc(submissionsRef, {
      submissions: [...currentSubmissions, submission]
    });
  }

  // If owner notifications are enabled, trigger the notification
  if (funnelData?.emailConfig?.notifyOwner) {
    await addDoc(collection(db, 'mail'), {
      to: funnelData.ownerEmail,
      subject: `Új beküldés - ${funnelData.siteName}`,
      text: `Új beküldés érkezett a "${funnelData.siteName}" oldalról.\n\nBeküldött adatok:\n${Object.entries(formData)
        .map(([key, value]) => `${key}: ${value}`)
        .join('\n')}`,
    });
  }
  
  console.log("Submission stored successfully");
  return { ...submission, id: funnelId };
};

export const updateSubmissionPaymentStatus = async (
  funnelId: string,
  submissionId: string,
  paymentStatus: 'success' | 'canceled' | 'pending'
) => {
  const submissionsRef = doc(db, 'funnel_submissions', funnelId);
  const submissionsDoc = await getDoc(submissionsRef);

  if (submissionsDoc.exists()) {
    const submissions = submissionsDoc.data().submissions;
    const updatedSubmissions = submissions.map((sub: FunnelSubmission) =>
      sub.id === submissionId ? { ...sub, paymentStatus } : sub
    );

    await updateDoc(submissionsRef, {
      submissions: updatedSubmissions
    });
  }
};

export const getFunnelSubmissions = async (funnelId: string): Promise<FunnelSubmission[]> => {
  console.log("Fetching submissions for funnel:", funnelId);
  
  const submissionsRef = doc(db, 'funnel_submissions', funnelId);
  const submissionsDoc = await getDoc(submissionsRef);

  if (!submissionsDoc.exists()) {
    return [];
  }

  const submissions = submissionsDoc.data().submissions || [];
  
  // Sort submissions by createdAt in descending order
  return submissions.sort((a: FunnelSubmission, b: FunnelSubmission) => 
    new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
};
